import { cn } from "utils";

export const Status = ({ value = "", className = "" }) => {
  if (!value) return <span>{"-"}</span>;

  value = value.toLowerCase();

  return (
    <span
      className={cn(
        "rounded-md bg-[#FFFFFF] text-[#000000] p-2 h-fit capitalize",
        {
          "bg-[#F0F6FF] text-[#3A88FC]": value === "in progress",
          "bg-[#EAFFEA] text-[#008000]":
            value === "delivered" || value === "paid",
          "bg-[#FFF3F3] text-[#FF0000]": value === "cancelled",
          "bg-[#E7FCFF] text-[#17A2B8]": value === "processing",
          "bg-[#FFFCF3] text-[#D2AA31]":
            value === "placed" || value === "pending" || value === "transit",
          "bg-[#E8F3FF] text-[#007BFF]": value === "shipped",
        },
        className
      )}
    >
      {value}
    </span>
  );
};
